import { AdditionalFieldsSourceType } from "enums/additional-fields-source-type";

define([
    "knockout",
    "services/additionalFieldsService",
    "core/resx",
    "underscore",
    "helpers/dateHelper",
    "helpers/routerHelper",
    "moment"
], function (ko, addFieldsService, resx, _, dateHelper, routerHelper, moment) {
    "use strict";

    var viewModel = (function () {
        var self = null;

        function ctor() {
            self = this;
            //#region Properties
            self.actions = {};
            self.workOrderId = ko.observable();
            self.readonly = false;
            self.additionalFieldsSource = AdditionalFieldsSourceType.FieldService;
            self.saveAdditionalFieldsButton = true;
            //#endregion
        }

        //#region Private Functions
        function bindViewModel(workOrderId, queryString) {
            var params = routerHelper.getQuerystring(queryString);
            self.readonly = !(params && params.readonly === "false");

            self.workOrderId(workOrderId);
        }

        function bindWidget() {
            self.actions = {
                getAll: addFieldsService.getAllForFieldService.bind(self, self.workOrderId()),
                setAll: addFieldsService.setAllForFieldService.bind(self, self.workOrderId())
        };
        }
        //#endregion

        //#region Public Functions
        ctor.prototype.activate = function (params ) {
            bindViewModel(params.workOrderId, params.q);
            bindWidget();
        };
        //#endregion
        return ctor;
    })();

    return viewModel;
});
